import { gql } from '@apollo/client';
import { FragProductReviewItem } from './frag-product-review-item';

export const FragReviewListItem = gql`
  ${FragProductReviewItem}

  fragment FragReviewListItem on review_lists {
    id
    title
    description
    approved
    updated_at
    created_at
    taste_list
    profiles {
      id
      username
      display_name
      photo_url
    }
    review_list_reviewsCollection {
      edges {
        node {
          product_reviews {
            ...FragProductReviewItem
          }
        }
      }
    }
  }
`;
